var map = {
	"./icon-app-store.svg": "9e1f",
	"./icon-google-play.svg": "2108",
	"./mx_seguromovil.svg": "d2a9",
	"./mx_seguromultidispositivo.svg": "02d1",
	"./mx_seguroportatil.svg": "0436"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3728";